export const COLORS = {
  PRIMARY_BLUE: '#44c9fa',
  PRIMARY_PINK: '#ff91a6',
  BACKGROUND_GREY: '#f5f5f5',
  TEXT_DARK: '#333333',
  WHITE: '#ffffff',
  SHADOW_COLOR: 'rgba(0, 0, 0, 0.1)',
  SHADOW_COLOR_HOVER: 'rgba(0, 0, 0, 0.2)',
};

export const NEW_YEARS_2026_DRIVE_LINK = 'https://drive.google.com/drive/folders/1FtvfQyzMiMqVkrTXvHKMs-gAtFVxm4MN?usp=sharing'

export const ZINE_SUBMISSION_FORM_LINK = 'https://forms.gle/UTqRWbgesWy1BXBq7'

export const NEWSLETTER_LINKS = {
  current: {
    month: 'January 2026',
    url: 'https://www.canva.com/design/DAG64JCMiFE/Fu6mPOob1v2rs97eNjorDw/view?utm_content=DAG64JCMiFE&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=hfd05800218',
  },
  past: [
    {
      month: 'December 2025',
    url: 'https://www.canva.com/design/DAG33DWr5j0/uznZVN2tKc7vHNEta8VW3Q/view?utm_content=DAG33DWr5j0&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h99f33bd92e',
  },
    {
      month: 'November 2025',
      url: 'https://www.canva.com/design/DAG1428lVz4/G6F8nwCtJguScqBrqrEP_A/view?utm_content=DAG1428lVz4&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h0c1901b5b2',
    },
    {
      month: 'October 2025',
      url: 'https://www.canva.com/design/DAGxw8KTOk8/dfNsRlVgCWenNyTh2mfP_Q/view?utm_content=DAGxw8KTOk8&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h9e08f9583c',
    },
    {
      month: 'September 2025',
      url: 'https://www.canva.com/design/DAGvt-8J-2g/Uv6yeU9YQia__j_l1rgm5Q/view?utm_content=DAGvt-8J-2g&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h1d8ecd2cac',
    },
    {
      month: 'August 2025',
      url: 'https://www.canva.com/design/DAGsJA0Mp7I/wje2JtAKOErgXZmJ3_-puA/view?utm_content=DAGsJA0Mp7I&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h0f27443dbf',
    },
    {
      month: 'July 2025',
      url: 'https://www.canva.com/design/DAGpgokk5L0/lmO41Q8VTMlu4Nf2XbD8rQ/view?utm_content=DAGpgokk5L0&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h74b6676927',
    },
    {
      month: 'June 2025',
      url: 'https://www.canva.com/design/DAGm0hRAxAg/WHMRpECUKKTIvggudI7e6g/view?utm_content=DAGm0hRAxAg&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h925b55a634',
    },
    {
      month: 'May 2025',
      url: 'https://www.canva.com/design/DAGjcFWXDi0/eZ7LD-uCNwd0M6_lEESjDw/view?utm_content=DAGjcFWXDi0&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h946dd6f84a',
    },
    {
      month: 'April 2025',
      url: 'https://www.canva.com/design/DAGi2bdnWHY/5bkplR1OKWGAJH-2VV5rug/view?utm_content=DAGi2bdnWHY&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=habf49a4208',
    },
    {
      month: 'March 2025',
      url: 'https://www.canva.com/design/DAGf-0CDtI4/LFesLcVsILWGVQhgS0vGWw/view?utm_content=DAGf-0CDtI4&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h8acbb184d2',
    },
  ],
}; 